import React, { useState } from 'react';
import { Typography, Container, Paper, Grid } from '@mui/material';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css'; // Import the Lightbox styles
import Zoom from 'yet-another-react-lightbox/plugins/zoom'; // Import the Zoom plugin
import { useTranslation } from 'react-i18next'; // Import useTranslation hook
import './App.css';

const Villas = () => {
  const { t, i18n } = useTranslation(); // Use the useTranslation hook
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [loadingStates, setLoadingStates] = useState({}); // Tracks loading state for each image

  const imagesGroup1 = [
    { src: '/VillasImages/IMG-1389.JPG' },
    { src: '/VillasImages/IMG-1388.JPG' },
    { src: '/VillasImages/IMG-1390.JPG' },
    { src: '/VillasImages/DaskKouzina.JPG' },
    { src: '/VillasImages/Ipnodomatio-Daskalaki_Em (1).JPG' },
    { src: '/VillasImages/Ipnodomatio-Daskalaki_Em (2).JPG' },
    { src: '/VillasImages/kouzinadaskalakis.JPG' },
    { src: '/VillasImages/Loutro - Daskal_Em (2).JPG' },
    { src: '/VillasImages/Loutro - Daskal_Em (3).JPG' },
  ];

  const imagesGroup2 = [
    { src: '/VillaLI/imageedit_22_3826251100.jpg' },
    { src: '/VillaLI/imageedit_1_3199745661.jpg' },
    { src: '/VillaLI/DSC_0839.jpg' },
    { src: '/VillaLI/imageedit_3_7187759230.jpg' },
    { src: '/VillaLI/imageedit_5_8421004487.jpg' },
    { src: '/VillaLI/imageedit_14_7993454067.jpg' },
    { src: '/VillaLI/imageedit_16_6822598358.jpg' },
    { src: '/VillaLI/imageedit_18_8143168379.jpg' },
    { src: '/VillaLI/imageedit_20_3548549609.jpg' },
  ];

  const imagesGroup3 = [
    { src: '/VillaDiamantakis/IMG_1472.png' },
    { src: '/VillaDiamantakis/IMG_1467.png' },
    { src: '/VillaDiamantakis/IMG_1473.png' },
    { src: '/VillaDiamantakis/DSC5876.jpg' },
    { src: '/VillaDiamantakis/DSC6297.jpg' },
    { src: '/VillaDiamantakis/DSC6300.jpg' },
    { src: '/VillaDiamantakis/DSC6317.jpg' },
    { src: '/VillaDiamantakis/DSC6329.jpg' },
    { src: '/VillaDiamantakis/DSF2562.jpg' },
  ];

  const allImages = [...imagesGroup1, ...imagesGroup2, ...imagesGroup3];

  const handleImageLoad = (index) => {
    setLoadingStates((prevState) => ({ ...prevState, [index]: false }));
  };

  const handleImageError = (index) => {
    setLoadingStates((prevState) => ({ ...prevState, [index]: false }));
  };

  return (
    <>
      {/* Group 1 */}
      <Container maxWidth="xl">
        <Paper elevation={3} className="home-paper">
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left', marginBottom: '0px' }}>
            {t('Tourist Villa')}
          </Typography>
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left', marginBottom: '0px' }}>
            {t('Architects: Aristomenis & George Varoudakis')}
          </Typography>
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left', marginBottom: '0px' }}>
            {t('Located in Korakies, Chania, Greece')}
          </Typography>
          <Grid container spacing={4} style={{ marginTop: '-10px' }}>
            {imagesGroup1.map((image, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <div style={{ position: 'relative', width: '100%', height: '300px' }}>
                  {loadingStates[index] !== false && (
                    <div className="loader" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                      <div className="spinner"></div>
                    </div>
                  )}
                  <img
                    className="fancy-image"
                    src={image.src}
                    alt={`Group1Image ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease-in-out',
                      display: loadingStates[index] === false ? 'block' : 'none',
                    }}
                    onClick={() => {
                      setPhotoIndex(index);
                      setLightboxOpen(true);
                    }}
                    onLoad={() => handleImageLoad(index)}
                    onError={() => handleImageError(index)}
                  />
                </div>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>

      {/* Group 2 */}
      <Container maxWidth="xl">
        <Paper elevation={3} className="home-paper">
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left', marginBottom: '0px' }}>
            {t('Villa Charlotte')}
          </Typography>
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left', marginBottom: '0px' }}>
            {t('Architects: Aristomenis & George Varoudakis')}
          </Typography>
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left', marginBottom: '0px' }}>
            {t('Located in Kalathas, Chania, Greece')}
          </Typography>
          <Grid container spacing={4} style={{ marginTop: '0px' }}>
            {imagesGroup2.map((image, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <div style={{ position: 'relative', width: '100%', height: '300px' }}>
                  {loadingStates[index + imagesGroup1.length] !== false && (
                    <div className="loader" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                      <div className="spinner"></div>
                    </div>
                  )}
                  <img
                    className="fancy-image"
                    src={image.src}
                    alt={`Group2Image ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease-in-out',
                      display: loadingStates[index + imagesGroup1.length] === false ? 'block' : 'none',
                    }}
                    onClick={() => {
                      setPhotoIndex(index + imagesGroup1.length);
                      setLightboxOpen(true);
                    }}
                    onLoad={() => handleImageLoad(index + imagesGroup1.length)}
                    onError={() => handleImageError(index + imagesGroup1.length)}
                  />
                </div>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>

      {/* Group 3 */}
      <Container maxWidth="xl">
        <Paper elevation={3} className="home-paper">
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left' }}>
            {t('Residential Villa')}
          </Typography>
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left' }}>
            {t('Architect: Emmanuel Segkos')}
          </Typography>
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left' }}>
            {t('Located in Marathi, Chania, Greece')}
          </Typography>
          <Grid container spacing={4} style={{ marginTop: '-10px' }}>
            {imagesGroup3.map((image, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <div style={{ position: 'relative', width: '100%', height: '300px' }}>
                  {loadingStates[index + imagesGroup1.length + imagesGroup2.length] !== false && (
                    <div className="loader" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                      <div className="spinner"></div>
                    </div>
                  )}
                  <img
                    className="fancy-image"
                    src={image.src}
                    alt={`Group3Image ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      display: loadingStates[index + imagesGroup1.length + imagesGroup2.length] === false ? 'block' : 'none',
                    }}
                    onClick={() => {
                      setPhotoIndex(index + imagesGroup1.length + imagesGroup2.length);
                      setLightboxOpen(true);
                    }}
                    onLoad={() => handleImageLoad(index + imagesGroup1.length + imagesGroup2.length)}
                    onError={() => handleImageError(index + imagesGroup1.length + imagesGroup2.length)}
                  />
                </div>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>

      {/* Lightbox */}
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={allImages}
        index={photoIndex}
        plugins={[Zoom]} // Add Zoom plugin
      />

      <a href={`/portfolio?lang=${i18n.language}`} className="return-to-portfolio-button">
        {t('Return to Portfolio')}
      </a>
    </>
  );
};

export default Villas;